import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { CustomLoader } from 'components/CustomLoader/CustomLoader';
import {
  decodeToken,
  isTokenAuthenticated,
  loadTokenFromStorage,
} from 'utils/token';

export const Route = createFileRoute('/auth/signup/_layout')({
  component: PrivateLayout,
  beforeLoad: async ({ location }) => {
    const token = loadTokenFromStorage();
    if (!isTokenAuthenticated(decodeToken(token))) {
      throw redirect({
        to: '/auth/login',
      });
    }
  },
  pendingComponent: () => <CustomLoader page />,
});

export default function PrivateLayout() {
  return <Outlet />;
}
